export default __webpack_public_path__ + "static/Fellix-Light-d1e702deced42cbc726e55893f424457.otf";